// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__r2oUU","contacts":"styles_contacts__1F8_C","social":"styles_social__3Vqbk"};